import { PublicDeleteUserFile, PublicDeleteUserImageByUserAndAccessMethod } from '../../../reduxToolkit/Invitation/InvitationApi';
import { accessMethodModel } from '../../../enums/accessMethodEnum';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {ValidationProcessCancel} from '../../../reduxToolkit/Visitor/VisitorApi';
import {useParams} from "react-router-dom";
import {getMainUrl} from "../Model/Models";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model getInvitationById: Model that contains all the information of the invitation.
 * @param String validationId: id of veridas.
 */
const HandleDeleteVeridasApp = ({ getInvitationById, validationId }) => {
    const { guardFlowId, userId, eventId } = useParams();
    const invitationId = getInvitationById?.invitation?.id ?? localStorage.getItem('invitationId');
    const mainUrl = getMainUrl({ invitationId, eventId, guardFlowId });
    // Prefer userId from URL params; fall back to visitorId from invitation data
    const resolvedUserId = userId ?? getInvitationById?.invitation?.visitorId;

    const dispatch = useDispatch();

    useEffect(() => {
        const invitation = getInvitationById?.invitation;

        if (resolvedUserId)  localStorage.setItem('visitorId', resolvedUserId);
        if (validationId)    localStorage.setItem('validationId', validationId);
        if (invitation?.id)  localStorage.setItem('invitationId', invitation.id);
    }, [getInvitationById, resolvedUserId]);

    const handleDelete = () => {
        const visitorId  = localStorage.getItem('visitorId');
        const validation = localStorage.getItem('validationId');

        if (visitorId) {
            dispatch(PublicDeleteUserFile(visitorId));
            dispatch(PublicDeleteUserImageByUserAndAccessMethod({
                userId: visitorId,
                accessMethodId: accessMethodModel.FACE_RECOGNITION.id
            }));
        }
        if (validation) {
            dispatch(ValidationProcessCancel(validation));
        }
    }

    const handleDeleteStorage = () => {
        localStorage.removeItem('visitorId');
        localStorage.removeItem('invitationId');
        localStorage.removeItem('validationId');
    }

    return {
        handleDelete,
        handleDeleteStorage,
        mainUrl
    }

};

export default HandleDeleteVeridasApp
